// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7769a3f1","453":"711e0bf0","732":"99f7ca55","977":"9b459adb"}[chunkId] + ".chunk.js";
};